import { DispenserBasicInfo } from '@/features/dispensers/components/dispenser-detail/subcomponents/basic-info-card/types.ts';
import { PropertyList } from '@/common/components/property-list/PropertyList.tsx';
import { Trans } from '@lingui/react/macro';
import { DetailCard } from '@/common/components/detail-card/DetailCard.tsx';
import { formatDateTime } from '@/common/utils/formatDateTime.ts';
import { formatNumber } from '@/common/utils/formatNumber.ts';

export interface BasicInfoCardProps {
  data: DispenserBasicInfo;
}

export const BasicInfoCard = ({ data }: BasicInfoCardProps) => {
  return (
    <DetailCard title={<Trans>Basic Information</Trans>}>
      <PropertyList>
        <PropertyList.Item label={<Trans>Serial Number</Trans>} value={data.sn} />
        <PropertyList.Item label={<Trans>Canisters</Trans>} value={formatNumber(data.canisters)} />
        <PropertyList.Item label={<Trans>Producer</Trans>} value={data.type.producer?.code} />
        <PropertyList.Item label={<Trans>Type</Trans>} value={data.type?.code} />
        <PropertyList.Item
          label={<Trans>Created</Trans>}
          value={formatDateTime(data.createdAt, 'dateTimeShort')}
        />
      </PropertyList>
    </DetailCard>
  );
};
